import moment from 'moment';

export default {
    autocompleteContact(query, id) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.get(
                ' ',
                {
                    _f: 'contacts',
                    type: 'thirdContact|staff',
                    action: 'autocompletionGroup',
                    value: query,
                    do: 'autocompletionGroup',
                    more: `thirdid_${id}|noBlockedStaff`,
                    linked: '',
                },
                (response) => {
                    resolve(response.root);
                },
                (err) => {
                    reject(err.response.data.error.message);
                },
            );
        });
    },
    persistContact(contact) {
        let marketingSubscriptions = [];
        contact.paramsSettings.marketing.forEach((marketing) => {
            if (!!marketing.value) {
                let value = marketing.code;
                switch (marketing.code) {
                    case 'textmsg':
                        value = 'sms';
                        break;
                    case 'mail':
                        value = 'postal_mail';
                    default:
                        break;
                }
                marketingSubscriptions.push(value);
            }
        });
        return {
            civility: contact.civility.value,
            first_name: contact.forename,
            last_name: contact.name,
            phone_number: contact.contactNumber.phoneNumber,
            mobile_number: contact.contactNumber.mobileNumber,
            fax_number: contact.contactNumber.faxNumber,
            social: {
                facebook: contact.paramsSettings.social.facebook,
                linkedin: contact.paramsSettings.social.linkedin,
                twitter: contact.paramsSettings.social.twitter,
                viadeo: null,
            },
            note: contact.paramsSettings.note,
            email: contact.email,
            position: contact.role,
            birth_date: contact.birthdate ? moment(contact.birthdate).format('YYYY-MM-DD') : null,
            sync: {
                mailchimp: contact.paramsSettings.syncProviders.mailchimp.isSetup,
                mailjet: contact.paramsSettings.syncProviders.mailjet.isSetup,
                simplemail: contact.paramsSettings.syncProviders.simplemail.isSetup,
            },
            marketing_campaigns_subscriptions: [...marketingSubscriptions],
        };
    },
    persistContactShorten(contact) {
        return {
            first_name: contact.forename,
            last_name: contact.name,
            email: contact.email,
            role: contact.role,
        };
    },
    updateContact(id, params = {}, data) {
        return ApiClient.put(`/contacts/${id}`, params, data);
    },
};
